import CreateSmallGroup from './component.jsx'
import { createInstanceContainer } from 'experienceComponents/CreateInstanceShared'

export default createInstanceContainer(CreateSmallGroup)
